(function () {
  const config = window.aimVariationsConfig || {};
  const siblings = window.productSiblings || [];

  function init() {
    if (config.enableTexturePicker) initTexturePicker();
    if (config.enableColorHover) initColorHover();
    if (config.enableVariantPrefetch) prefetchSiblingImages();
  }

  function prefetchSiblingImages() {
    if (!siblings.length) return;

    const run = () => {
      siblings.forEach(sibling => {
        if (!sibling.image) return;
        const img = new Image();
        img.decoding = 'async';
        img.src = sibling.image;
      });
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 2000 });
    } else {
      setTimeout(run, 1500);
    }
  }

  function formatTexture(texture) {
    if (!texture) return '';
    return config.showTextureFirstWordOnly ? texture.split(' ')[0] : texture;
  }

  function hasMultipleTextures() {
    const textures = new Set();
    siblings.forEach(p => {
      const t = formatTexture(p.texture);
      if (t) textures.add(t);
    });
    const current = formatTexture(config.currentTexture);
    if (current) textures.add(current);
    return textures.size > 1;
  }

  function canShowTextureInLabel() {
    return !config.hideTextureIfSingle || hasMultipleTextures();
  }
  function initTexturePicker() {
    const pickerWrapper = document.querySelector('[data-texture-picker]');
    if (!pickerWrapper || pickerWrapper.dataset.textureInit) return;
    pickerWrapper.dataset.textureInit = 'true';

    const swatchContainer = document.querySelector('.variant-picker__option-values');
    if (!swatchContainer) return;

    function filterSwatches(selected) {
      swatchContainer.querySelectorAll('a.thumbnail-swatch').forEach(a => {
        const handle = a.getAttribute('href').replace('/products/', '');
        const product = siblings.find(p => p.handle === handle);
        if (!product) return;
        a.style.display = (selected === 'All' || product.texture === selected) ? 'block' : 'none';
      });
    }

    const buttons = pickerWrapper.querySelectorAll('button[data-option]');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => {
          b.setAttribute('aria-pressed', 'false');
          b.querySelector('span').style.opacity = '0';
        });
        btn.setAttribute('aria-pressed', 'true');
        btn.querySelector('span').style.opacity = '1';
        filterSwatches(btn.dataset.option);
      });
    });

    const activeBtn = pickerWrapper.querySelector('button[aria-pressed="true"]');
    filterSwatches(activeBtn ? activeBtn.dataset.option : 'All');
  }

  function initColorHover() {
    const swatchContainer = document.querySelector('.variant-picker__option-values');
    if (!swatchContainer) return;
    if (swatchContainer.dataset.hoverInit) return;
    swatchContainer.dataset.hoverInit = 'true';

    const activeColorLabel = swatchContainer
      .closest('.variant-picker__option')
      ?.querySelector('.h-stack span:not(.sr-only)');
    if (!activeColorLabel) return;

    const baseColorText = activeColorLabel.textContent.trim();

    function getRestingLabel() {
      const textureLabel = formatTexture(config.currentTexture);
      if (config.showTextureByDefault && textureLabel && canShowTextureInLabel()) {
        return `${textureLabel} ${baseColorText}`;
      }
      return baseColorText;
    }

    function setRestingLabel() {
      activeColorLabel.textContent = getRestingLabel();
    }

    setRestingLabel();

    document.querySelectorAll('[data-texture-picker] button[data-option]').forEach(btn => {
      btn.addEventListener('click', setRestingLabel);
    });

    swatchContainer.querySelectorAll('a.thumbnail-swatch').forEach(a => {
      const handle = a.getAttribute('href').replace('/products/', '');
      const product = siblings.find(p => p.handle === handle);
      if (!product) return;

      const colorOnly = product.color;
      const textureLabel = formatTexture(product.texture);

      a.addEventListener('mouseenter', () => {
        if (config.showTextureOnHover && textureLabel && canShowTextureInLabel()) {
          activeColorLabel.textContent = `${textureLabel} ${colorOnly}`;
        } else {
          activeColorLabel.textContent = colorOnly;
        }
      });

      a.addEventListener('mouseleave', setRestingLabel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();